import React from "react"
import { ENV } from "../../settings"

// Components
import "./style.css"

const ShareButtons = (props) => {
    const { pathname, href } = window.location
    let url = ""

    // Gjør en sjekk på domene i stede for ENV. 
    if (ENV === "local" || ENV === "test") {
        url = `http://devdel.kirkesok.no/api${pathname}`
    } else if (ENV === "staging") {
        url = `https://stagingdel.kirkesok.no/api${pathname}`
    } else {
        url = `https://del.kirkesok.no/api${pathname}`
    }

    const copyLink = () => {
        const copyText = document.getElementById("devurl")
        const twitterSpan = document.getElementById("devurlParent")
        copyText.select()
        document.execCommand("copy")
        twitterSpan.classList.add("share-btn__link--success")

        setTimeout(() => {
            twitterSpan.classList.remove("share-btn__link--success")
        }, 5000)
    }

    const FB_APP_ID = "1523575444415281"
    const baseUrl = "https://res.cloudinary.com/kirkesok/image/upload/w_600"
    const imageUrl = props.image && `${baseUrl}/v${props.image.version}/${props.image.public_id}.jpg`

    return (
        <div className="share-btn__wrapper">
            <a className="share-btn share-btn__facebook"
                target="_blank"
                title="Del på Facebook"
                href={`https://www.facebook.com/dialog/feed?app_id=${FB_APP_ID}&redirect_uri=${href}&link=${url}&picture=${imageUrl}`}>
                <i>Facebook</i>
            </a>
            <a className="share-btn share-btn__twitter"
                target="_blank"
                title="Del på Twitter"
                href={`https://twitter.com/intent/tweet?text=${url}`}>
                <i>Twitter</i>
            </a>
            <span id="devurlParent" onClick={copyLink} className="share-btn share-btn__link" title="Kopier delingslenke">
                <i>Link</i>
                <input id="devurl" value={url} onChange={() => {return}} />
            </span>
        </div>
    )
}

export default ShareButtons



// WEBPACK FOOTER //
// ./src/components/ShareButtons/index.js